// extracted by mini-css-extract-plugin
module.exports = {"area":"style_area__yJHDo","title":"style_title__30shk","contents":"style_contents__2uE-b"};